"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trimLabels = exports.VISUALISATION_COLORS = exports.tooltipFormatter = void 0;
var tooltipFormatter = function (value, name, props) {
    if (name.toLowerCase() === "value")
        name = "Total";
    name = toTitleCase(name);
    return [value, name, props];
};
exports.tooltipFormatter = tooltipFormatter;
var toTitleCase = function (str) {
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};
var UNASSIGNED_COLOR = "#999999";
exports.VISUALISATION_COLORS = {
    PURPLE: ["#bfa1ff", "#834ff1", "#3d00c1", UNASSIGNED_COLOR],
    ORANGE: ["#f49d4e", "#f7820d", "#cc660a", UNASSIGNED_COLOR],
    TEAL: ["#b0faff", "#2ae1ee", "#0197a1", UNASSIGNED_COLOR],
    CORAL: ["#feae95", "#ed7650", "#ac5337", UNASSIGNED_COLOR],
    YELLOW: ["#fdd886", "#ffc036", "#dc9700", UNASSIGNED_COLOR],
    INDICATOR: ["#308096", "#095971", "#093d4c", UNASSIGNED_COLOR]
};
function trimLabels(data) {
    var firstWord = data.split(" ")[0];
    if (firstWord.length > 4)
        firstWord = data.substring(0, 3);
    return firstWord;
}
exports.trimLabels = trimLabels;
